import NavigationBar from '@/components/common/NavigationBar/index.vue'
import PageLoader from '@/components/common/PageLoader/index.vue'
import CommonMixin from '@/mixins/commonMixin'
import { listenEventFromPinaToVuex, removeEventListenerFromPiniaToVuex } from '@/utils/pinia-event-listerner.js'
import { pages } from '@vue3/configs'
import { clearSessionUpdatedDate, clearFcmTokens } from '../utils/common'
import { mapGetters } from 'vuex'

const MOBILE_WIDTH = 768
const TABLET_MIN_WIDTH = 769
const TABLET_MAX_WIDTH = 1023

export default {
  name: 'App',
  components: { PageLoader, NavigationBar },
  mixins: [CommonMixin],
  methods: {
    initPage () {
      this.handleResize()
    },
    attachResizeHandler () {
      window.addEventListener('resize', this.handleResize)
    },
    detachResizeHandler () {
      window.removeEventListener('resize', this.handleResize)
    },
    handleResize (currentWidth) {
      const windowWidth =
        typeof currentWidth === 'number'
          ? currentWidth
          : document.documentElement.clientWidth
      if (windowWidth <= MOBILE_WIDTH) {
        this.$store.commit('setMobileDeviceStatus', true)
        this.$store.commit('setTabletDeviceStatus', false)
      } else if (windowWidth >= TABLET_MIN_WIDTH && windowWidth <= TABLET_MAX_WIDTH) {
        this.$store.commit('setTabletDeviceStatus', true)
        this.$store.commit('setMobileDeviceStatus', false)
      } else {
        this.$store.commit('setMobileDeviceStatus', false)
        this.$store.commit('setTabletDeviceStatus', false)
      }
      this.adjustBodyHeight()
    },
    hideLoader () {
      this.$store.commit('setShowLoader', false)
    },
    getAppConfiguration () {
      const query = {
        id: 'applereseller.ui.config',
        requestId: 'apple-reseller-ui',
        clientId: 'apple-reseller-ui',
        storeId: '10001',
        channelId: this.getIsMobile ? 'mobile' : 'web'
      }
      this.$store.dispatch('GET_APP_CONFIGURATION', {
        query,
        success: this.hideLoader,
        fail: this.hideLoader
      })
    },
    adjustBodyHeight () {
      const windowHeight = window.innerHeight
      document.body.style.height = windowHeight + 'px'
    }
  },
  computed: {
    ...mapGetters(['getIsLoggedIn', 'getIsAppConfigFetched']),
    ...mapGetters(['getShowLoader', 'getErrorCode', 'getIsMobile', 'getHideHeaderNavigation', 'getAppConfigs']),
    ...mapGetters('npsStore', ['getShowNpsPopup']),
    isSelectedTabEqualsRoute () {
      return this.$route.name === this.$route.meta.headerTabGroup
    },
    showHeader () {
      const showHeader = this.getIsAppConfigFetched && this.getIsLoggedIn && !this.getHideHeaderNavigation && (!this.getIsMobile || this.isSelectedTabEqualsRoute)
      return showHeader
    },
    currentPath () {
      return window.location.pathname
    }
  },
  watch: {
    getErrorCode (value) {
      if (value === 401) {
        if (this.$route.meta.auth) {
          this.$store.commit('setIsLoggedIn', false)
          this.$store.commit('setShowLoader', true)
          this.$router.push({ path: pages.login })
        }
        clearSessionUpdatedDate()
        clearFcmTokens()
      }
    }
  },
  created () {
    this.initPage()
    this.$store.dispatch('GET_USER_INFO')
  },
  mounted () {
    this.attachResizeHandler()
    this.$store.commit('setShowLoader', true)
    this.getAppConfiguration()
    this.adjustBodyHeight()
    listenEventFromPinaToVuex()
  },
  destroyed () {
    this.detachResizeHandler()
    removeEventListenerFromPiniaToVuex()
  }
}
